import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DotGridFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DotGridFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M21 3v4h-4V3h4ZM7 14v-4H3v4h4ZM21 14v-4h-4v4h4ZM7 7V3H3v4h4ZM21 17v4h-4v-4h4ZM14 14v-4h-4v4h4ZM14 3v4h-4V3h4ZM14 21v-4h-4v4h4ZM7 17v4H3v-4h4Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default DotGridFilled;